import { createStore } from 'vuex';
import QuestionModule from './questions';
import VideosModule from '@/store/videos';
import UiModule from '@/store/ui';
import AuthModule from '@/store/auth';
import ClientsModule from '@/store/clients';
import AnswersModule from '@/store/answers';
import UsersModule from '@/store/users';
import StatusModule from '@/store/status';
import IdentityModule from '@/store/identity';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    questions: QuestionModule,
    videos: VideosModule,
    ui: UiModule,
    auth: AuthModule,
    clients: ClientsModule,
    answers: AnswersModule,
    users: UsersModule,
    status: StatusModule,
    identity: IdentityModule,
  },
});
